import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { GoogleComponent } from '../../../../../components/newUI/GoogleComponent/GoogleComponent';
import { Input } from '../../../../../components/newUI/Input/Input';
import { TextArea } from '../../../../../components/newUI/TextArea/TextArea';
import { UpdateInformationAboutObjectRequest } from '../../../../../store/slices/dashboardSlice/types/dashboardSchema';
import cls from '../ModalUpdateInfoAboutObject.module.css';

interface ModalBodyUpdateInfoAboutObjectProps {
    form: UpdateInformationAboutObjectRequest;
    onForm: (name: string, value: string) => void;
    onCoordinates: (value: { latitude: number; longitude: number }) => void;
    handleAddressSubmit?: () => Promise<void>;
    mapCenter: { lat: number; lng: number };
}

export const ModalBodyUpdateInfoAboutObject = memo(
    ({
        form,
        onForm,
        onCoordinates,
        handleAddressSubmit,
        mapCenter,
    }: ModalBodyUpdateInfoAboutObjectProps) => {
        const { t } = useTranslation();

        return (
            <form className={cls.bodyContent}>
                <Input
                    value={form.name}
                    label={t('ModalBodyUpdateInfoAboutObject.return.inputName.label')}
                    placeholder={t('ModalBodyUpdateInfoAboutObject.return.inputName.placeholder')}
                    errorMessage=""
                    inputName="name"
                    onChange={onForm}
                    maxLength={255}
                />
                <Input
                    value={form.address}
                    label={t('ModalBodyUpdateInfoAboutObject.return.inputAddress.label')}
                    errorMessage=""
                    placeholder={t(
                        'ModalBodyUpdateInfoAboutObject.return.inputAddress.placeholder'
                    )}
                    inputName="address"
                    onChange={onForm}
                    maxLength={255}
                    onEnterPress={handleAddressSubmit}
                />
                <div className={cls.map}>
                    <GoogleComponent
                        mapCenter={mapCenter}
                        lat={form.coordinates.latitude}
                        lng={form.coordinates.longitude}
                        onCoordinates={onCoordinates}
                    />
                </div>
                <div className={cls.inputRow}>
                    <Input
                        classes={cls.inputRowItem}
                        value={form.contract_number}
                        label={t('ModalBodyUpdateInfoAboutObject.return.inputContractNumber.label')}
                        placeholder={t(
                            'ModalBodyUpdateInfoAboutObject.return.inputContractNumber.placeholder'
                        )}
                        errorMessage=""
                        inputName="contract_number"
                        onChange={onForm}
                        maxLength={255}
                    />
                    <Input
                        classes={cls.inputRowItem}
                        value={form.contract_date}
                        label={t('ModalBodyUpdateInfoAboutObject.return.inputContractDate.label')}
                        errorMessage=""
                        placeholder={t(
                            'ModalBodyUpdateInfoAboutObject.return.inputContractDate.placeholder'
                        )}
                        inputName="contract_date"
                        onChange={onForm}
                        maxLength={255}
                    />
                </div>
                <TextArea
                    classes={cls.textArea}
                    inputName="description"
                    onChange={onForm}
                    value={form.description}
                    label={t('ModalBodyUpdateInfoAboutObject.return.textarea.label')}
                    maxLength={500}
                />
            </form>
        );
    }
);
